import React from "react";
import { i18n } from "../../translate/i18n";
import { exibeMotivoFalha } from "../../helpers/motivoDeFalha";

// Motivo de falha de um registro (campanha/agendamento) a partir do texto cru.
// Com codigo da Meta: titulo + acao + link; o original fica em <details>, que
// abre por toque (tooltip nao existe no celular). Sem codigo: o texto original.
const MotivoFalha = ({ reason, fallback = "" }) => {
  const m = exibeMotivoFalha(reason);
  if (!reason) return fallback ? <span>{fallback}</span> : null;
  const quebra = { overflowWrap: "anywhere", wordBreak: "break-word", minWidth: 0 };
  return (
    <span style={{ display: "block", whiteSpace: "normal", overflow: "visible", textOverflow: "clip", ...quebra }} data-testid="motivo-falha">
      <span style={{ display: "block", fontWeight: m.temCodigo ? 600 : "inherit" }}>{m.titulo}</span>
      {m.acao ? <span style={{ display: "block" }}>{m.acao}</span> : null}
      {m.link ? (
        <a href={m.link} target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", minHeight: 44, padding: "0 4px" }}>
          {i18n.t("metaErrors.fixAt")}
        </a>
      ) : null}
      {m.temCodigo && m.original ? (
        <details style={{ fontSize: "0.85em", opacity: 0.8 }}>
          <summary style={{ cursor: "pointer" }}>{i18n.t("metaErrors.showDetails")}</summary>
          <span style={{ display: "block" }}>{m.original}</span>
        </details>
      ) : null}
    </span>
  );
};

export default MotivoFalha;
